require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { ServicePricingForm } from './components/ServicePricing';
import ServiceDetailsStore from './components/ServicePricing/ServiceDetailsStore';
import { Provider } from 'mobx-react';

const providedServicePricingForm = (
    <Provider serviceDetailsStore={new ServiceDetailsStore()}>
        <ServicePricingForm />
    </Provider>
);

const servicePricingFormRoot = document.getElementById("servicePricing");
if (servicePricingFormRoot) {
    ReactDOM.render(providedServicePricingForm, servicePricingFormRoot);
}

